<template>
	<div class="row">
		<div class="col-12 col-md-4 offset-md-4 mt-5">
			<GetOTP/>
		</div>
	</div>
</template>

<script>
import GetOTP from '../Widgets/ResetPassword/GetOTP.vue';

export default {
  name: 'ObtenerOTP',
  components: {
    GetOTP,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
